<template>
    <v-carousel style="box-shadow: none;" :height="'150px'" hide-controls hide-delimiters interval="5000">
        <v-carousel-item v-for="(item,i) in items" :key="i">
            <div style="padding: 20px; text-align: left; color: #000;">
                <span style="font-weight: 600;">{{ item.title }}</span><br/>
                <div>
                    <span style="float: right">
                        {{ item.name }}
                    </span>
                    <mdi style="color: orange; margin: 0;" v-for="s in item.stars" size="16">mdiStar</mdi>
                </div>
                <div style="margin: 16px 0 0px 0; font-style: italic; font-weight: 400; font-size: 14px">{{ item.text }}</div>
            </div>
        </v-carousel-item>
    </v-carousel>
</template>

<script>
const items = [
    {
        stars: 5,
        name: "Dr. Piyush Singh",
        title: "Essential for dentists",
        text: "Excellent, I can very clearly demonstrate what stage the patient is in and what the treatment will result.",
    },
    {
        stars: 5,
        name: "Dr. Qanza Afzal",
        title: "Excellent",
        text: "I being a dental professional will highly recommend this app. I'm having great experience using this app.😃",
    },
    {
        stars: 5,
        name: "Dr. Nidal Abdallah",
        title: "Very helpful",
        text: "Perfect job to let patients know what they well get after any treatment also helps to educate patients more.",
    },
    {
        stars: 5,
        name: "Dr. Geet Malhotra",
        title: "Best app",
        text: "Best app for patient education. A real boon for the dentist.",
    },
    {
        stars: 5,
        name: "Dr. Sebastian AO",
        title: "Very useful for me as a dentist!",
        text: "Using DentiCalc, it was very easy for me to explain treatments and give the patient an idea about our prices!",
    },
    {
        stars: 5,
        name: "UK TOOTH CARE",
        title: "Best app ever!",
        text: "Wonderful app for dentists to explain patients and can do treatment planning also in good way",
    },
];

export default {
    data() {
        return {
            items: items.sort(() => (Math.random() > .5) ? 1 : -1),
        }
    }
};
</script>
